import { findDeepGetActivityOfTask } from '../../../../views/lookahead/planification/index.helper';
import {
  findDeepGetTaskRecursive,
  isGrouped
} from '../../GanttVisualization.helper';
import {
  formatValueData,
  isTaskDisabled,
  renderNonTask,
  renderTaskContent,
  testWrapped
} from './utils';

const navigatorLang = navigator.language || navigator.userLanguage;

const RenderDuration = ({
  task = {},
  column = {},
  t = () => 'fake translation'
}) => {
  /** No Render if parent is Abstract */
  if (isGrouped()) return testWrapped();

  /** Check if data is defined. Activity don't have this data */
  if (!task.isTask) return renderNonTask(task, column, t);
  /** get activity reference */
  const activityReference = findDeepGetActivityOfTask(
    window.activities,
    'id',
    task.id
  );
  if (!activityReference) return testWrapped();

  /** get reference task (taskFromLookahead) from activities */
  const taskFromLookahead = findDeepGetTaskRecursive(
    window.activities,
    'id',
    task.id
  );

  /** gett the cell value */
  let valueData = taskFromLookahead[column?.name]
    ? parseFloat(taskFromLookahead[column?.name]).toLocaleString('en-US')
    : 0;
  valueData = formatValueData(valueData, navigatorLang);

  /** disabled value for parent tasks, get parent task  */
  const disabled = isTaskDisabled(taskFromLookahead);
  const child = renderTaskContent(taskFromLookahead, column, t, {
    valueData,
    disabled,
    task
  });
  return testWrapped(child);
};

export default RenderDuration;
